import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `
<div [class]="divClasses" [class.dark]="dark">
  <ng-container *ngFor="let num of lines">
    <div [style.transform]="transform(num)" [style.animation-delay]="delay(num)"></div>
  </ng-container>
</div>`,
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent implements OnInit {

  private lineNumber = 10;

  lines: number[];

  /**
   * speed in % (default is 50)
   *
   * @memberof SpinnerComponent
   */
  @Input() speed = 50;

  /**
   * size in px (default is 64)
   *
   * @memberof SpinnerComponent
   */
  @Input() size = 'l';

  @Input() dark = false;

  constructor() {
    this.lines = [];
    for (let i = 0; i < this.lineNumber; i++) {
      this.lines.push(i);
    }
  }

  ngOnInit() {
  }

  get divClasses(): string {
    switch (this.size) {
      case 's':
        return 'evt-spinner evt-spinner-s';
      case 'l':
        return 'evt-spinner evt-spinner-l';
      default:
        throw new Error('invalid spinner size: ' + this.size);
    }
  }

  transform(num): string {
    return `rotate(${360 / this.lineNumber * num}deg)`;
  }

  delay(num): string {
    return `-${1 - 1 / this.lineNumber * num}s`;
  }

}
